import { MutationKey } from "@tanstack/react-query";

export const addKeyToMutationResult = <T extends object, M extends MutationKey>(
  result: T,
  mutationKey: M
): T & { mutationKey: M } => {
  return new Proxy(result as T & { mutationKey: M }, {
    get(target, prop, receiver) {
      if (prop === "mutationKey") {
        return mutationKey;
      }
      return Reflect.get(target, prop, receiver);
    },
  });
};
